/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';
import classNames from 'classnames';
import { getColorSchema } from './helpers/getColorSchema';
import Button from '$/components/Button';

export interface Props {
  color: string;
  title: string;
  subtitle: string;
  isActive: boolean;
  index: number;
  onPress: (index: number) => void;
}
export const ProductCampaingSelectButton = ({
  title,
  subtitle,
  isActive,
  index,
  onPress,
  color,
}: Props) => {
  const colorSchema = getColorSchema(color);
  return (
    <Button
      variant="text"
      className={classNames(
        'h-auto w-full rounded-radius/button border p-spacing/gap/soft-12px bg-white md:p-[10px]',
        {
          'border-colors/neutral-gray-300': !isActive,
          [colorSchema.button.border]: isActive,
        },
      )}
      onClick={() => onPress(index)}
    >
      <div
        style={{ width: `100%` }}
        className="flex min-w-46 flex-col gap-spacing/padding/soft-4px md:min-w-[210px] lg:min-w-[250px]"
      >
        <h3
          className={classNames(
            colorSchema.button.text,
            'mhg-alpha-typography-bullet-1',
            {
              'text-colors/neutral-gray-900': !isActive,
              [colorSchema.button.text]: isActive,
            },
          )}
        >
          {title}
        </h3>
        <span className="mhg-alpha-typography-badge truncate px-2 text-colors/neutral-gray-800">
          {subtitle}
        </span>
      </div>
    </Button>
  );
};
